import { forwardRef } from 'react';
import type { ComponentPropsWithRef } from 'react';

type ContentIconBgProps = ComponentPropsWithRef<'svg'> & {
    size?: number;
    darkMode?: boolean;
    highlightColor?: string;
};

const ContentIconBg = forwardRef<SVGSVGElement, ContentIconBgProps>(
    ({ size = 28, darkMode = false, highlightColor = null, ...restProps }, ref) => {
        return (
            <svg
                ref={ref}
                width={size}
                height={size}
                viewBox="0 0 26 26"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <title>Combined Shape</title>
                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Elements/Content/Type"
                        fill={highlightColor ?? (darkMode ? '#0f121e' : '#FFFFFF')}>
                        <path
                            d="M27.9943328,1.8369702e-16 L27.9943328,28.0038605 L25.9943328,28.0038605 L25.9943205,26.0490399 C25.9896275,23.5375931 24.6414871,22.1879131 21.9498992,22 L21.9498992,22 L11.9943328,22 C8.68062429,22 5.99433279,19.3137085 5.99433279,16 L5.99433279,6.04580688 C5.99433279,3.36886395 4.68795187,2.02033776 2.07519002,2.00022831 L0,2 L0,0 L27.9943328,1.8369702e-16 Z"
                            id="Combined-Shape"></path>
                    </g>
                </g>
            </svg>
        );
    }
);
ContentIconBg.displayName = 'ContentIconBg';

export default ContentIconBg;
